import { Customer } from '../../../../entities/@account/Customer/Customer';
import {
    FormErrors,
    FormValidation,
    validateDateOfBirth,
    validateEmailAddress,
    validateForm,
    validatePhoneNumber,
    validateRequiredString,
} from '../../../../entities/@forms/FormValidation/FormValidationService';

export type CustomerFormErrors = FormErrors<Customer>;

export const validateCustomerForm = (formData: Customer): FormValidation<CustomerFormErrors> => {
    const errors: CustomerFormErrors = {
        firstName: validateRequiredString('firstName', formData.firstName),
        lastName: validateRequiredString('lastName', formData.lastName),
        email: validateEmailAddress(formData.email),
        birthday: formData.birthday
            ? validateDateOfBirth(formData.birthday)
            : undefined,
        phoneNumber: validatePhoneNumber(formData.phoneNumber),
    };

    return validateForm<CustomerFormErrors>(errors);
};
